import React, { useState, useEffect } from 'react'

import { Products, Navbar, Cart, Checkout } from './Components'
import { commerce } from './lib/commerce'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'


function App() {

    const [products, setProducts] = useState([]);
    const [cart, setCarts] = useState({});
    const [order, setOrder] = useState({});
    const [errorMessage, setErrorMessage] = useState('');

    const fetchProducts = async () => {
        const { data } = await commerce.products.list();
        setProducts(data)
    }

    const fetchCart = async () => {
        const cart = await commerce.cart.retrieve();
        setCarts(cart)
    }

    const handleAddToCart = async (productId, quantity) => {
        const { cart } = await commerce.cart.add(productId, quantity)
        setCarts(cart)
    }
    const handleUpdateCartQty = async (productId, quantity) => {
        const { cart } = await commerce.cart.update(productId, { quantity })
        setCarts(cart)
    }
    const handleRemoveFromCart = async (productId) => {
        const { cart } = await commerce.cart.remove(productId)
        setCarts(cart)
    }
    const handleEmptyCart = async () => {
        const { cart } = await commerce.cart.empty();
        setCarts(cart)
    }

    const refreshcart = async () => {
        const newCart = await commerce.cart.refresh();

        setCarts(newCart)
    }

    const handleCaptureCheckout = async (checkoutTokenId, newOrder) => {
        try {
            const incomingOrder = await commerce.checkout.capture(checkoutTokenId, newOrder);
            setOrder(incomingOrder)
        } catch (error) {
            setErrorMessage(error.data.error.message)
        }
    }

    useEffect(() => {
        fetchProducts();
        fetchCart();
    }, [])
    return (
        <Router>
            <div>
                <Navbar totalItem={cart.total_items} />
                <Switch>
                    <Route exact path={"/"} ><Products products={products} onAddToCart={handleAddToCart} /></Route>
                    <Route exact path={"/cart"} >
                        <Cart
                            cart={cart}
                            handleEmptyCart={handleEmptyCart}
                            handleRemoveFromCart={handleRemoveFromCart}
                            handleUpdateCartQty={handleUpdateCartQty}
                        />
                    </Route>
                    <Route exact to={"/checkout"} >
                        <Checkout 
                            cart={cart} 
                            order={order}
                            onCaptureCheckout={handleCaptureCheckout}
                            error={errorMessage}
                        />
                    </Route>
                </Switch>
            </div>
        </Router>
    )
}

export default App
